// JiraSearch.js
import { useState, useEffect } from 'react';
import { FluxRadio } from '@meltwater/flux-web-components-react';
import { Grid, Typography, Box, Button, Paper } from '@mui/material';
import { SendGridService } from '../../services/sendgrid.service';
import { AlertTrackingService } from '../../services/alerttracking.service';
import TrackedCompany from './trackedcompany';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import styles from './sendgrid.module.css';
import Addtracking from './addtracking';

// op=opportunity or account
const Newsletterstatus = () => {
  const [data, setData] = useState([{}]);
  const [breload, setbReload] = useState([true]);
  const [blockdata, setBlockdata] = useState([{}]);
  const [datatype, setDatatype] = useState('bounces')
  const [groupeddata, setGroupeddata] = useState([]);
  const [groupedblockdata, setGroupedblockdata] = useState([]);

  function getCountsByDay(data) {
    const companyData = [];
    data.forEach(company => {
      const counts = {
        day1: 0,
        day2: 0,
        day3: 0,
        day4: 0,
        day5: 0,
        day6: 0,
        day7: 0,
        week2: 0,
        week3: 0,
        week4: 0,
        week5plus: 0
      };
      company.data.forEach(item => {
        const createdTime = new Date(item.created * 1000);
        const daysDifference = Math.floor((Date.now() - createdTime) / (1000 * 60 * 60 * 24));

        if (daysDifference >= 0 && daysDifference < 7) {
          counts[`day${daysDifference + 1}`]++;
        } else if (daysDifference >= 7 && daysDifference < 14) {
          counts.week2++;
        } else if (daysDifference >= 14 && daysDifference < 21) {
          counts.week3++;
        } else if (daysDifference >= 21 && daysDifference < 28) {
          counts.week4++;
        } else {
          counts.week5plus++;
        }
      });
      companyData.push({
        companyId: company.companyid,
        companyName: company.companyname,
        counts: counts
      });
    });
    return companyData;
  }

  useEffect(() => {
    async function fetchData() {
      let myres;
      try {
        myres = await SendGridService.getnewsletterblocks()
        const bucketdata = getCountsByDay(myres.data.data.data)
        
        setGroupedblockdata(bucketdata);
        setBlockdata(myres.data.data.data)
      } catch (error) {
        console.log(`FAIL`, error);
      }
    }
    if (breload) {
      fetchData();
      setbReload(false);
    }
  }, [breload]);

  useEffect(() => {
    async function fetchData() {
      let myres;
      try {
        myres = await SendGridService.getnewsletterbounces()

        const bucketdata = getCountsByDay(myres.data.data.data)
        setGroupeddata(bucketdata);
        setData(myres.data.data.data)
      } catch (error) {
        console.log(`FAIL`, error);
      }
    }
    if (breload) {
      fetchData();
      setbReload(false);
    }
  }, [breload]);

  // Function to render the table with company data
  const renderCompanyTable = (companyData) => {
    const pixwidth = 7;
    return (
      <div className={styles.tableContainer}>
        <table className={styles.styledTable}>
          <thead>
            <tr>
              <th></th>
              <th style={{ width: '20%' }}>Company Name</th>
              <th style={{ width: `${pixwidth}` }}>Day 1</th>
              <th style={{ width: `${pixwidth}` }}>Day 2</th>
              <th style={{ width: `${pixwidth}` }}>Day 3</th>
              <th style={{ width: `${pixwidth}` }}>Day 4</th>
              <th style={{ width: `${pixwidth}` }}>Day 5</th>
              <th style={{ width: `${pixwidth}` }}>Day 6</th>
              <th style={{ width: `${pixwidth}` }}>Day 7</th>
              <th style={{ width: `${pixwidth}` }}>Week 2</th>
              <th style={{ width: `${pixwidth}` }}>Week 3</th>
              <th style={{ width: `${pixwidth}` }}>Week 4</th>
              <th style={{ width: `${pixwidth}` }}>90day</th>
            </tr>
          </thead>
          <tbody>
            {companyData.map(company => (
              <tr key={company.companyId}>
                <td style={{ width: '8%', textAlign: 'left'}}>
                  <Button 
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => removeCompany(company)}
                  >
                    Remove
                  </Button>
                </td>
                <td style={{ width: '12%', textAlign: 'left', fontSize:'large'}}>
                  <a href={`/sendgrid/${company.companyId}/status`}>
                    {company.companyName}
                  </a>
                </td>
                <td className={company.counts.day1 !== 0 && company.counts.day1 !== null ? styles['red-cell'] : styles['green-cell']}>
                  {company.counts.day1}
                </td>
                <td className={company.counts.day2 !== 0 && company.counts.day2 !== null ? styles['orange-cell'] : styles['green-cell']}>
                  {company.counts.day2}
                </td>
                <td className={company.counts.day3 !== 0 && company.counts.day3 !== null ? styles['orange-cell'] : styles['green-cell']}>
                  {company.counts.day3}
                </td>
                <td className={company.counts.day4 !== 0 && company.counts.day4 !== null ? styles['orange-cell'] : styles['green-cell']}>
                  {company.counts.day4}
                </td>
                <td className={company.counts.day5 !== 0 && company.counts.day5 !== null ? styles['orange-cell'] : styles['green-cell']}>
                  {company.counts.day5}
                </td>
                <td className={company.counts.day6 !== 0 && company.counts.day6 !== null ? styles['orange-cell'] : styles['green-cell']}>
                  {company.counts.day6}
                </td>
                <td className={company.counts.day7 !== 0 && company.counts.day7 !== null ? styles['orange-cell'] : styles['green-cell']}>
                  {company.counts.day7}
                </td>
                <td className={company.counts.week2 !== 0 && company.counts.week2 !== null ? styles['orange-cell'] : styles['green-cell']}>
                  {company.counts.week2}
                </td>
                <td className={company.counts.week3 !== 0 && company.counts.week3 !== null ? styles['orange-cell'] : styles['green-cell']}>
                  {company.counts.week3}
                </td>
                <td className={company.counts.week4 !== 0 && company.counts.week4 !== null ? styles['orange-cell'] : styles['green-cell']}>
                  {company.counts.week4}
                </td>
                <td className={company.counts.week5plus !== 0 && company.counts.week5plus !== null ? styles['orange-cell'] : styles['green-cell']}>
                  {company.counts.week5plus}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  
  // Function to handle company removal
  const removeCompany = async (company) => {
    console.log("remove ", company);
    try {
      await AlertTrackingService.removeCompany(company);
      if (datatype === 'bounces') {
        setGroupeddata(prevData => prevData.filter(item => item.companyId !== company.companyId));
      } else {
        setGroupedblockdata(prevData => prevData.filter(item => item.companyId !== company.companyId));
      }
      setbReload(true);
    } catch (error) {
      console.error("Failed to remove company:", error);
    }
  };
 
  return (
    <div className={styles.container}>
      {!groupeddata ? (
        <Box className={styles.centeredContent} sx={{ py: 4 }}>
          <Typography variant="h5">Loading...</Typography>
        </Box>
      ) : (
        <>
          <div className={styles.headerContainer}>
            <div className={styles.headerRow}>
              <Button 
                className={styles.backButton}
                onClick={() => window.history.back()}
                startIcon={<ArrowBackIcon />}
              >
                Back
              </Button>
              <Typography variant="h6" className={styles.tableHeader}>
                Newsletter Suppression Dashboard
              </Typography>
            </div>
            <div className={styles.buttonRow}>
              <Addtracking reload={setbReload} />
            </div>
          </div>
          
          {/* Main content */}
          <Paper className={styles.tableContainer} sx={{ mb: 4 }}>
            {/* Company data table */}
            {renderCompanyTable(datatype === 'bounces' ? groupeddata : groupedblockdata)}
          </Paper>
          
          <Box sx={{ mt: 3, mb: 2, px: 2 }}>
            <Grid container spacing={3} alignItems="center">
              <Grid item>
                <Typography variant="h6">Data Type:</Typography>
              </Grid>
              <Grid item>
                <FluxRadio checked={datatype === 'bounces'} onClick={() => setDatatype('bounces')}> Bounces</FluxRadio>
              </Grid>
              <Grid item>
                <FluxRadio checked={datatype === 'blocks'} onClick={() => setDatatype('blocks')}> Blocks</FluxRadio>
              </Grid>
            </Grid>
          </Box>
          
          {datatype === 'bounces' && data && data.length > 0 && (
            <div>
              {data.map((item, idx) => (
                <TrackedCompany key={`bounce_${idx}`} item={item} idx={`bounce_${idx}`} />
              ))}
            </div>
          )}
          
          {datatype === 'blocks' && blockdata && blockdata.length > 0 && (
            <div>
              {blockdata.map((item, idx) => (
                <TrackedCompany key={`block_${idx}`} item={item} idx={`block_${idx}`} />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Newsletterstatus;
